import React from 'react';
import { Handle, Position } from 'reactflow';
import { MergeOutlined } from '@ant-design/icons';

const JoinNode = ({ data, selected }) => {
  return (
    <div className={`react-flow__node-join ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Left}
        id="input1"
        style={{
          background: '#fa8c16',
          border: '2px solid #fff',
          width: '8px',
          height: '8px',
          top: '30%'
        }}
      />
      
      <Handle
        type="target"
        position={Position.Left}
        id="input2"
        style={{
          background: '#fa8c16',
          border: '2px solid #fff',
          width: '8px',
          height: '8px',
          top: '70%'
        }}
      />
      
      <div style={{ 
        padding: '12px', 
        display: 'flex', 
        alignItems: 'center', 
        gap: '8px',
        minWidth: '140px'
      }}>
        <MergeOutlined style={{ fontSize: '16px', color: '#fa8c16' }} />
        <div>
          <div style={{ fontWeight: '500', fontSize: '13px' }}>
            {data.config?.node_name || data.label}
          </div>
          {data.config?.joinType && (
            <div style={{ fontSize: '11px', color: '#666' }}>
              {data.config.joinType} join
            </div>
          )}
        </div>
      </div>
      
      <Handle
        type="source"
        position={Position.Right}
        style={{
          background: '#fa8c16',
          border: '2px solid #fff',
          width: '8px',
          height: '8px'
        }}
      />
    </div>
  );
};

export default JoinNode;